var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeIcon = function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 47,
    fill: "none",
    viewBox: "0 0 52 47"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CD1543",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.453,
    d: "m51 30.784-3.47 3.469L26 8.59 4.47 34.253 1 30.783l21.811-25.99L26 .99l3.189 3.802zM25.96 8.59V.99m19.98 31.367H6.06m35.324-5.431H10.615m12.684 0V11.811m5.404 15.115V11.813M11.378 32.528v12.99m-6.08 0v-9.432m41.404 0v9.432m-6.08 0v-12.99"
  })));
};
export default SvgHomeIcon;